/* Troy Akin Pickleball — theme scripts */
(function () {
  'use strict';

  // Header: solid background once the page scrolls (overlay mode on the homepage)
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = header.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-nav]');
    if (!toggle || !drawer) return;
    var setOpen = function (open) {
      drawer.classList.toggle('is-open', open);
      header.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.querySelector('[data-icon-open]').hidden = open;
      toggle.querySelector('[data-icon-close]').hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    toggle.addEventListener('click', function () { setOpen(!drawer.classList.contains('is-open')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  // Fade-up on scroll
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  // YouTube: load the player only when someone clicks play
  function initVideos(scope) {
    (scope || document).querySelectorAll('[data-youtube]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-youtube');
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
        iframe.title = btn.getAttribute('aria-label') || 'YouTube video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        btn.parentNode.replaceChild(iframe, btn);
      });
    });
  }

  // Product page: gallery thumbs, quantity, variant → price / availability
  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-product]').forEach(function (root) {
      var main = root.querySelector('.pdp__main img');
      root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.getAttribute('data-thumb');
          main.removeAttribute('srcset');
          root.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });

      root.querySelectorAll('[data-qty]').forEach(function (wrap) {
        var input = wrap.querySelector('input');
        wrap.querySelectorAll('[data-step]').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
            input.value = v;
          });
        });
      });

      var json = root.querySelector('[data-variants]');
      var select = root.querySelector('[data-variant-select]');
      if (!json || !select) return;
      var variants = JSON.parse(json.textContent);
      var price = root.querySelector('[data-price]');
      var compare = root.querySelector('[data-compare]');
      var button = root.querySelector('[data-add]');
      select.addEventListener('change', function () {
        var v = variants.find(function (x) { return String(x.id) === select.value; });
        if (!v) return;
        if (price) price.textContent = v.price;
        if (compare) { compare.textContent = v.compare || ''; compare.hidden = !v.compare; }
        if (button) {
          button.disabled = !v.available;
          button.querySelector('span').textContent = v.available ? button.dataset.labelAdd : button.dataset.labelSold;
        }
        if (v.image && main) { main.src = v.image; main.removeAttribute('srcset'); }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  // Collection sort
  function initSort() {
    document.querySelectorAll('[data-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        window.location.href = url.toString();
      });
    });
  }

  function init(scope) { initReveal(); initVideos(scope); initProduct(scope); }

  document.addEventListener('DOMContentLoaded', function () { initHeader(); initSort(); init(); });
  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); if (e.target.querySelector('[data-header]')) initHeader(); });
})();
